module.exports = __webpack_public_path__ + "static/media/gtelpay.25dd6ee6.png";